import { Component, Input, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { PaymentPlanPreview } from '../models/payment-plan-preview.model';
import { Payment } from '../models/payment.model';
import { PaymentTerm } from '../models/payment-term.model';
import { SeFeThemesLoader } from 'se-fe-themes';

@Component({
  selector: 'app-payment-plan-preview',
  templateUrl: './payment-plan-preview.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PaymentPlanPreviewComponent implements OnChanges {
  hasCustomDates: boolean;
  installments: Payment[];
  totalAmount: number;
  upfrontPayment: Payment;
  dueInFull: boolean;
  upfrontPaymentAmount: number;

  @Input() paymentTerm: PaymentTerm;
  @Input() previewData: PaymentPlanPreview;
  @Input() paymentTermForm: FormGroup;
  @Input() saleType: string;
  @Input() itemized: boolean;
  @Input() termSelectionDisabled?: boolean;
  @Input() showPartialAmountInput?: boolean;

  constructor() {
    SeFeThemesLoader.load({
      supportedThemes: 'light',
      url: 'https://se-fe-angular-services.ui.sportngin.com'
    });
   }

  ngOnChanges(): void {
    this.hasCustomDates = this.paymentTerm.payment_term_strategy.strategy_type === 'custom_date';
    this.installments = this.previewData.payments.filter(payment => !payment.upfront_payment);
    this.totalAmount = this.previewData.payments.reduce((total, payment) => total + Number(payment.amount), 0);
    this.upfrontPayment = this.previewData.payments.find(payment => payment.upfront_payment);
    this.upfrontPaymentAmount = this.upfrontPayment ? Number(this.upfrontPayment.amount) : 0;
    this.dueInFull = this.paymentTerm.payment_term_strategy.strategy_type === 'due_in_full';
  }
}
